<template>
    <div style="height: 100vh">
        <div class="row h-100 mx-0">
            <div class="col-0 col-lg-5 d-none d-lg-flex px-0">
                <div class="h-100 w-100 sb-image-background">
                    <div
                        class="h-100 d-flex align-items-center justify-content-center text-center"
                        style="
                            background-color: rgba(84, 19, 136, 0.4);
                            text-shadow: 1px 1px 5px black;
                        "
                    >
                        <div>
                            <h1 class="text-white font-weight-normal mb-4 hero-title">
                                <strong>TN CyberTech Bank</strong>
                            </h1>
                            <h2 class="text-white">
                                Everyday Banking For Everyday People
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-7 pr-0 pr-lg-1 d-flex align-items-center px-0">
                <div class="col-12">
                    <p class="text-center mt-5">Step 3 / 4</p>
                    <div class="text-center">
                        <h1>Set Pin</h1>
                        <h2>Please set the pin for your profile</h2>
                    </div>

                    <div
                        class="row d-flex justify-content-center align-items-center mt-5"
                    >
                        <div class="col-10 col-lg-6">
                            <form
                                v-bind:class="{ 'ui form loading': isBusy() }"
                                @submit.prevent="submitForm()"
                            >
                                <div class="ui big fluid left icon input mt-3">
                                    <i class="shield alternate icon"></i>
                                    <input
                                        type="number"
                                        v-model="model.pin"
                                        maxlength="4"
                                        placeholder="Pin"
                                    />
                                </div>
                                <small>Max length = 4</small>
                                <small v-if="errors.pin" class="text-danger">{{
                                    errors.pin
                                }}</small>
                                <small v-if="!isValidPin" class="text-danger mt-1">
                                    Pin is required and must 4 digit digits
                                </small>

                                <small
                                    v-if="errors.messageNotReadable"
                                    class="text-danger"
                                    >{{ errors.messageNotReadable }}</small
                                >
                                <small
                                    v-if="errors.generalExceptionx"
                                    class="text-danger"
                                    >{{ errors.generalException }}</small
                                >
                                <small v-if="errors.apiException" class="text-danger">{{
                                    errors.apiException
                                }}</small>

                                <button
                                    class="fluid ui button mt-3"
                                    v-bind:disabled="isBusy() || !isFormValid"
                                    type="submit"
                                >
                                    Submit
                                </button>
                                <br />
                                <a @click="close()" class="fluid ui grey tertiary button"
                                    >Cancel</a
                                >
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { Notify } from "@/utils/notifications";
import { URLS } from "@/utils/constants";

export default {
    name: "SetPin",
    data() {
        return {
            model: {
                provider: "CHANNEL",
                action: "CREDENTIALS",
                phone: localStorage.getItem("phone"),
                pin: "",
            },
            errors: {},
            operations: 0,
        };
    },
    mounted() {
        if (!this.$route.params.sdkActionUid) {
            this.actionCheckNotification();
        }
    },
    computed: {
        isValidPin() {
            let panRegex = new RegExp("\\d{4}");
            return !!this.model.pin && panRegex.test(this.model.pin);
        },

        isFormValid() {
            return this.isValidPin;
        },
    },
    methods: {
        close() {
            // todo: send close request to backend
        },
        actionCheckNotification() {
            Notify.fire(
                "Oops",
                "There seems to be a problem loading this page. Please go back to the previous page and try again.",
                "error"
            );
        },
        submitForm() {
            if (!this.$route.params.sdkActionUid) {
                this.actionCheckNotification();
                return;
            }
            this.postNoAuth(URLS.auth, this.model, "Pin set successful", null, true).then(
                (res) => {
                    if (!res) return;
                    if (res.errors) return (this.errors = res.errors);
                    this.$router.push("/questions/" + this.$route.params.sdkActionUid);
                }
            );
        },
        ...baseMethods,
    },
};
</script>

<style scoped></style>
